/** Store links. */
export const LINKS = {
  webApp: 'https://web.music24.app',
  iosAppStore:
    'https://apps.apple.com/us/app/music24-jewish-music-radio/id6797684242',
  /** Package is already com.favio.android.j24 */
  androidPlayStore:
    'https://play.google.com/store/apps/details?id=com.favio.android.j24',
  site: 'https://music24.app',
  downloadApp: 'https://music24.app/download-app',
  downloadPage: '/download',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms',
  supportEmail: 'support@music24.app',
} as const

export function detectMobilePlatform(
  ua = typeof navigator !== 'undefined' ? navigator.userAgent : '',
): 'ios' | 'android' | 'other' {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  // iPadOS 13+ may report as Mac with touch
  if (
    typeof navigator !== 'undefined' &&
    navigator.platform === 'MacIntel' &&
    navigator.maxTouchPoints > 1
  ) {
    return 'ios'
  }
  if (/Android/i.test(ua)) return 'android'
  return 'other'
}

export function storeUrlForPlatform(
  platform: 'ios' | 'android' | 'other',
): string {
  if (platform === 'ios') return LINKS.iosAppStore
  if (platform === 'android') return LINKS.androidPlayStore
  return LINKS.downloadPage
}

/** Phones/tablets — use store redirect instead of desktop QR. */
export function isMobileClient(
  ua = typeof navigator !== 'undefined' ? navigator.userAgent : '',
): boolean {
  return detectMobilePlatform(ua) !== 'other'
}
